import React from "react";
var __jsx = React.createElement;
import { useStoreState } from "pullstate";
import Store from "../../../utils/Store";
import Draggable from "react-draggable";
import { useState, useCallback, memo, useEffect, useRef } from "react";
import AwesomeIcon from "../../AwesomeIcon";
import { faWindowMaximize } from "@fortawesome/pro-regular-svg-icons";
import getEnv from "../../../utils/getEnv";
import { get } from "lodash";
var NODE_ENV = getEnv("NODE_ENV");
var isProdEnv = NODE_ENV === "production";
var DraggableModal = /*#__PURE__*/memo(function (_ref) {
  var children = _ref.children;
  var _useStoreState = useStoreState(Store, function (s) {
      return {
        isDraggableModalOpen: s.isDraggableModalOpen,
        isDraggableModalMinimized: s.isDraggableModalMinimized,
        isDraggableModalMaximized: s.isDraggableModalMaximized,
        userInfo: s.userInfo
      };
    }),
    isDraggableModalOpen = _useStoreState.isDraggableModalOpen,
    userInfo = _useStoreState.userInfo,
    isDraggableModalMinimized = _useStoreState.isDraggableModalMinimized,
    isDraggableModalMaximized = _useStoreState.isDraggableModalMaximized;
  var modalRef = useRef(null);

  // get the isAIEnabled from userInfo
  var isAIAssistantEnabled = get(userInfo, ["settings", "ui_settings", "ai_assistant"], false);
  var _useState = useState(false),
    isDragging = _useState[0],
    setIsDragging = _useState[1];
  var _useState2 = useState({
      x: 0,
      y: 0
    }),
    position = _useState2[0],
    setPosition = _useState2[1];
  useEffect(function () {
    var _window$matchMedia;
    var isMobile = (_window$matchMedia = window.matchMedia("(max-width: 639px)")) === null || _window$matchMedia === void 0 ? void 0 : _window$matchMedia.matches;
    Store.update(function (s) {
      s.isDraggableModalOpen = !isProdEnv && isAIAssistantEnabled && !isMobile;
    });
  }, []);
  var handleDragStart = useCallback(function () {
    setIsDragging(true);
  }, []);
  var handleDragStop = useCallback(function (e, data) {
    setIsDragging(false);
    setPosition({
      x: data.x,
      y: data.y
    });
  }, []);
  var handleRestore = useCallback(function () {
    Store.update(function (s) {
      s.isDraggableModalMinimized = false;
    });
    setPosition({
      x: 0,
      y: 0
    });
  }, []);
  if (!isDraggableModalOpen) return null;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "fixed inset-0 z-50 flex items-start justify-end pointer-events-none transition-opacity duration-300 ".concat(isDraggableModalOpen ? "opacity-100" : "opacity-0")
  }, /*#__PURE__*/React.createElement(Draggable, {
    handle: ".drag-handle",
    onStart: handleDragStart,
    onStop: handleDragStop,
    grid: [50, 50],
    position: isDraggableModalMaximized ? {
      x: 0,
      y: 0
    } : position,
    disabled: isDraggableModalMaximized,
    bounds: "parent"
  }, /*#__PURE__*/React.createElement("div", {
    ref: modalRef,
    className: "relative bg-white dark:bg-gray-900 rounded-lg shadow-[0_0_15px_rgba(0,0,0,0.1)] dark:shadow-[0_0_15px_rgba(0,0,0,0.3)] ".concat(isDraggableModalMaximized ? "w-full h-[100vh] m-0" : "w-[calc(40%-2rem)] max-w-[calc(40%-2rem)] h-[98vh] mt-4 mr-4 border border-teal-500 dark:border-teal-400", " overflow-auto flex flex-col pointer-events-auto will-change-transform transition-all duration-300 ease-in-out ").concat(!isDragging && "transition-transform duration-300 ease-in-out", " ").concat(isDraggableModalOpen ? "translate-x-10" : "translate-x-full", " ").concat(isDraggableModalMinimized ? "hidden" : "")
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col h-full pb-1 ".concat(isDraggableModalMaximized ? "w-[70%] mx-auto border border-gray-100 dark:border-gray-800" : "")
  }, children)))), isDraggableModalMinimized && /*#__PURE__*/React.createElement("div", {
    className: "fixed right-[calc(6rem)] top-[60px] z-[100]"
  }, /*#__PURE__*/React.createElement("button", {
    onClick: handleRestore,
    className: "bg-teal-500 hover:bg-teal-600 text-white py-3 px-5 rounded-lg shadow-[0_8px_24px_rgba(0,0,0,0.25)] hover:shadow-[0_12px_32px_rgba(0,0,0,0.35)] transition-all duration-300 hover:scale-110 pointer-events-auto group flex items-center space-x-2",
    "aria-label": "Restore"
  }, /*#__PURE__*/React.createElement(AwesomeIcon, {
    name: faWindowMaximize,
    size: "lg",
    className: "text-white"
  }), /*#__PURE__*/React.createElement("span", {
    className: "opacity-0 w-0 overflow-hidden group-hover:opacity-100 group-hover:w-auto transition-all duration-300 whitespace-nowrap"
  }, "Restore"))));
});
DraggableModal.displayName = "DraggableModal";
export default DraggableModal;